import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '&:not(.grayText)': {
      '& .description': {
        fontWeight: 500,
        color: 'var(--primary-main)',
      },
    },

    '&.grayText': {
      '& .description': {
        color: 'var(--text-secondary)',
      },
    },

    '& .stateIcon': {
      color: 'var(--primary-main)',
    },

    '&.xs': {
      '& .stateIcon': {
        '& svg': {
          width: '40px',
          height: '40px',

          '@media screen and (min-width: 1441px)': {
            width: '48px',
            height: '48px',
          },
        },
      },
    },

    '&.sm': {
      '& .stateIcon': {
        '& svg': {
          width: '160px',
          height: '160px',
        },
      },
    },

    '&.lg': {
      '& .stateIcon': {
        '& svg': {
          width: '256px',
          height: '256px',
        },
      },
    },

    '& .description': {
      fontSize: '15px',
      lineHeight: '22.5px',

      '@media screen and (min-width: 1441px)': {
        fontSize: '18px',
        lineHeight: '27px',
      },
    },
  },
}));

export default useStyles;
